import React from 'react';
import { Container, Wrapper } from '../../app/styles';

import Modulos from './components/Modules';

const Modules: React.FC = () => (
  <Container>
    <Wrapper>
      <h2>Escolha um módulo</h2>
      <Modulos />
    </Wrapper>
  </Container>
);

export default Modules;
